// components/common/seo.js
import * as React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

function Seo({ description, lang, meta, title }) {
  const { site } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
        }
      }
    }
  `)

  const cleaned = typeof description === "string" ? description.trim() : description
  const metaDescription = cleaned && cleaned.length ? cleaned : site.siteMetadata.description
  const defaultTitle = site.siteMetadata?.title

  return (
    <Helmet
      htmlAttributes={{ lang }}
      title={title}
      titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : null}
      meta={[
        { key: "description", name: "description", content: metaDescription },
        { key: "og:title", property: "og:title", content: title },
        { key: "og:description", property: "og:description", content: metaDescription },
        { key: "og:type", property: "og:type", content: "website" },
      ].concat(meta)}
    />
  )
}

Seo.defaultProps = { lang: "en", meta: [], description: "" }
Seo.propTypes = { description: PropTypes.string, lang: PropTypes.string, meta: PropTypes.arrayOf(PropTypes.object), title: PropTypes.string.isRequired }
export default Seo
